export const getIsBecauseYouPlayed = (cid: string) => cid === 'because_you_played-all-dynamic-category-because_you_played-all';
